import Choices from "choices.js";

let element = document.querySelector('#educator_selector');

if (element) {

    var multipleFetch = new Choices('#educator_selector', {
        allowHTML: false,
        placeholder: true,
        placeholderValue: 'Eğitmen seçin',
        removeItemButton: true,
        loadingText: 'Yükleniyor...',
        noResultsText: 'Arama sonucu bulunamadı',
        noChoicesText: 'Seçecek değer bulunamadı',
        itemSelectText: 'Seçmek için tıklayın',
      }).setChoices(function() {
        return fetch(
          '/admin/api/educators',
        )
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            return data.map(function(educator) {
              return { value: educator.id, label: educator.title };
            });
          });
      });

}


